import { useMutation } from '@tanstack/react-query';

import { verifyOtp } from '../api/auth.api';

import { useAuth } from './useAuth';

/** Verify the OTP and sign the new customer in. The signup session is
 *  remembered (persisted) so a reload keeps them logged in. */
export function useVerifyOtp() {
  const { acceptSession } = useAuth();

  return useMutation({
    mutationFn: verifyOtp,
    onSuccess: (session) => acceptSession({ ...session, remember: true }),
  });
}
